<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="three_menu">
					<dl>
						<dd v-for="(item,index) in joinMenu" :key="index" :class="{ cur : index == threeCurID }" @click="threeFun(item,index)">{{item.title}}</dd>
					</dl>
				</div>
				<div class="three_div-wp">
					<div class="three_div">
						<div class="join-jl">
							<input type="text" class="btn btn-default" v-if="this.swich" value="填写简历" @click="deliverTo(id)">
						</div>
						<div class="single_detail" v-html="content"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'branch',
		data(){
			return{
				title:'',
				titleEn:'',
				joinMenu:[],
				threeCurID:0,
				content:'',
				id:'',
				swich:false
			}
		},
		methods:{
			res_menuClass(e){
				this.axios.get('/api/menus/class?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = ''
							this.titleEn = ''
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
							this.res_joinMenu(e)
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_joinMenu(e){
				this.axios.get('/api/news/listNews?category_id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.joinMenu = response.data.reslut;
							this.res_joinDetail(this.joinMenu[0].id)
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_joinDetail(e){
				this.axios.get('/api/news/newsView?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.content = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
							this.id = response.data.reslut.id;
							this.swich = true;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			threeFun(item,index){
				this.content = "";
				this.threeCurID = index;
				this.swich = false;
				this.res_joinDetail(item.id)
			},
			deliverTo(e){
				console.log('e00e',e,this.$route);
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/slider/'+ this.$route.params.id +'/deliver',
					query:{
						id:e
					}
				})
			}
		},
		created(){
			this.res_menuClass(this.$route.query.category_id)
		}
	}
</script>

<style>
</style>